const style = {
  thumbStyle: {
    backgroundColor: 'rgb(145,153,154)',
    width: '10px',
  },
  verticalBar: {
    position: 'absolute',
    width: '10px',
    right: '0px',
    bottom: '2px',
    top: '0px',
    borderRadius: '3px',
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/JumperScrollbar/JumperScrollbar.styles.js